<template>
    <transition name="fade">
        <div class="be-scroll-top" v-show="visible"></div>
    </transition>
</template>

<script>
    export default {
        props: {
            offset: {
                default: 220,
            },
        },

        data: () => ({
            visible: false,
        }),

        methods: {
            toggleVisibility() {
                this.visible = window.pageYOffset > this.offset;
            },

            scrollToTop(e) {
                e.preventDefault();
                this.$scrollTo('#app');
            },
        },

        mounted() {
            window.addEventListener('scroll', this.toggleVisibility);
            this.$el.addEventListener('touchstart', this.scrollToTop);
            this.$el.addEventListener('mouseup', this.scrollToTop);
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .be-scroll-top {
        display: block;

        &.fade-enter-active,
        &.fade-leave-active {
            transition: opacity .5s;
        }

        &.fade-enter,
        &.fade-leave-to {
            opacity: 0;
        }
    }
</style>
